export const initialState = {
    // currentUser: {}
    loggedIn: false,
    moduleAccess : undefined,
    usrSession: {}
};
const authReducer = (state = { ...initialState }, action) => {
    switch (action.type) {
        case 'SESSION_SET':
            // return { ...state, currentUser: action.payload }
            return {
                loggedIn: true,
                usrSession: { ...action.payload },
                moduleAccess : undefined,
            }
        case 'SESSION_DESTROY':
            // return { ...state, currentUser: {} }
            return {
                loggedIn: false,
                usrSession: {},
                moduleAccess : undefined,
            }
        case 'MODULES_SET':
            // return { ...state, currentUser: action.payload }
            return {
                loggedIn: state.loggedIn,
                usrSession: state.usrSession,
                moduleAccess : action.payload
            }
        case 'MODULES_UNSET':
                // return { ...state, currentUser: action.payload }
            return {
                loggedIn: state.loggedIn,
                usrSession: state.usrSession,
                moduleAccess : undefined
            }    
        default:
            return state;
    }
};
export default authReducer;
